//better pattern:
// const fundMap = {
//   1 : 316,
//   2 : 279, 
//   ///
// }

import UserFund from "../../entities/UserFund";

// getFund(num) {
//   return fundMap[num];
// }

export function getFundCertificateNumber(fundCode: number) {
  switch (fundCode) {
    case 1:
      return "316";
    case 2:
      return "279";
    case 3:
      return "313";
    case 4:
      return "332";
    case 5:
      return "360";
    case 6:
      return "307";
    case 7:
      return "212";
    case 8:
      return "274";
    case 10:
      return "999";
    case 16:
      return "507";
    default:
      return "";
  }
}

export const getFundCode = (userFunds: UserFund[] , currentFirstLabel:string) => {  
  const fund = userFunds.filter(
      (userFund: UserFund) => currentFirstLabel === `${userFund.fundLabel}`
  );
  if (fund.length) return parseInt(fund[0].fundCode);
  return 0;
};
